import { render, staticRenderFns } from "./EstimatesOldSpecsItemSidepageHeader.vue?vue&type=template&id=6346f30e&"
import script from "./EstimatesOldSpecsItemSidepageHeader.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldSpecsItemSidepageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports